import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    header: {
        id: '_.funding_requirements.header',
        defaultMessage:
            "You're drawing down {drawdownAmount} with repayments over {loanDuration}{tooltip}"
    },
    interestOnlyHeader: {
        id: '_.funding_requirements.interestOnlyHeader',
        defaultMessage: 'Your loan with repayments over {loanDuration}'
    },
    duration: {
        id: '_.funding_requirements.duration',
        defaultMessage: '{loanDuration} months'
    },
    tooltip: {
        id: '_.funding_requirements.tooltip',
        defaultMessage:
            "You can adjust your choice by clicking 'Go back' below."
    },
    subHeader: {
        id: '_.funding_requirements.subheader',
        defaultMessage:
            'Before we can send funds to your account, we need you to complete a few final steps'
    },
    interestOnlySubHeader: {
        id: '_.funding_requirements.interestOnlySubHeader',
        defaultMessage:
            'Before we can extend your loan, you need to complete a few final steps'
    },
    loadingText: {
        id: '_.funding_requirements.loading_text',
        defaultMessage: 'One moment, we’re checking your status...'
    },
    backButton: {
        id: '_.funding_requirements.back_button',
        defaultMessage: 'Go Back'
    },
    incompleteTabTitle: {
        id: '_.funding_requirements.incomplete_tab_title',
        defaultMessage: 'Incomplete'
    },
    completeTabTitle: {
        id: '_.funding_requirements.complete_tab_title',
        defaultMessage: 'Complete'
    }
});
